import React from 'react';

// Original lantern brand mark — drawn from primitives, not a copyrighted logo.
// Used by ChildLogin and SubjectSelector. Keeps its glow keyframe self-contained
// so callers don't need to remember to declare it.
export default function LanternMark({ size = 64, glow = true }) {
  return (
    <div style={{ position: 'relative', width: size, height: size, display: 'inline-block' }}>
      <style>{`
        @keyframes lantern-glow {
          0%, 100% { opacity: 0.85; transform: scale(1); }
          50%      { opacity: 1;    transform: scale(1.08); }
        }
      `}</style>
      {glow && (
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            inset: -size * 0.35,
            background:
              'radial-gradient(circle, rgba(245,158,11,0.45) 0%, rgba(245,158,11,0.15) 35%, rgba(245,158,11,0) 70%)',
            animation: 'lantern-glow 2.8s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />
      )}
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', display: 'block' }}
        aria-hidden="true"
      >
        <path d="M28 6 Q32 2 36 6" stroke="#1A1F36" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        <line x1="32" y1="6" x2="32" y2="11" stroke="#1A1F36" strokeWidth="2.5" strokeLinecap="round" />
        <rect x="20" y="11" width="24" height="5" rx="2" fill="#1A1F36" />
        <rect x="22" y="9" width="20" height="3" rx="1.5" fill="#2A3148" />
        <defs>
          <linearGradient id="lantern-glass" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FCD34D" />
            <stop offset="55%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#D97706" />
          </linearGradient>
          <radialGradient id="lantern-flame" cx="0.5" cy="0.55" r="0.45">
            <stop offset="0%" stopColor="#FFFBEB" />
            <stop offset="50%" stopColor="#FDE68A" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#FDE68A" stopOpacity="0" />
          </radialGradient>
        </defs>
        <path
          d="M18 18 Q18 16 20 16 H44 Q46 16 46 18 V44 Q46 46 44 46 H20 Q18 46 18 44 Z"
          fill="url(#lantern-glass)"
        />
        <ellipse cx="32" cy="32" rx="11" ry="13" fill="url(#lantern-flame)" />
        <line x1="26" y1="16" x2="26" y2="46" stroke="#1A1F36" strokeWidth="1.5" opacity="0.55" />
        <line x1="38" y1="16" x2="38" y2="46" stroke="#1A1F36" strokeWidth="1.5" opacity="0.55" />
        <line x1="18" y1="31" x2="46" y2="31" stroke="#1A1F36" strokeWidth="1" opacity="0.35" />
        <rect x="20" y="46" width="24" height="5" rx="2" fill="#1A1F36" />
        <rect x="24" y="51" width="16" height="3" rx="1.5" fill="#2A3148" />
        <path
          d="M32 26 Q34 30 33 33 Q35 31 35 34 Q35 38 32 38 Q29 38 29 35 Q29 32 31 30 Q30 27 32 26 Z"
          fill="#FFFBEB"
          opacity="0.85"
        />
      </svg>
    </div>
  );
}
